import { Injectable } from '@angular/core';
import { UserService } from './user.service';

@Injectable()
export class SettingsService {

    private settingsCache = null;
    private localStorageKey: string;

    constructor(private userService: UserService) {
        this.localStorageKey = 'sessionSettings';
        if (userService.authUser) {
            this.localStorageKey = `sessionSettings-${userService.authUser.email + '-' + userService.authUser.partyMemberId }`;
        }
    }

    storeSetting(id: string, value: any, useDaaS?: boolean): void {
        if (!id) { return; }

        const currSettings: setting[] = this.getAllSettings();
        let toStore = currSettings.find((set) => set.name === id);
        if (toStore) {
            toStore.value = value;
        } else {
            toStore = <setting>{name: id, value: value};
            currSettings.push(toStore);
        }

        this.settingsCache = currSettings;
        // This will be updated to use localstorage, or daas.
        localStorage.setItem(this.localStorageKey, JSON.stringify(currSettings));
    }

    clearSetting(id: string): void {
        if (!id) { return; }

        const currSettings: setting[] = this.getAllSettings();
        const toRemove = currSettings.findIndex((set) => set.name === id);

        if ( toRemove < 0) { return; }

        currSettings.splice(toRemove, 1);

        this.settingsCache = currSettings;
        localStorage.setItem(this.localStorageKey, JSON.stringify(currSettings));
    }

    clearAllLocalStorage(): void {
        localStorage.removeItem(this.localStorageKey);
    }

    getSetting(id: string): setting {
        const currSettings = this.getAllSettings();
        const value = currSettings.find((set) => set.name === id);
        return value;
    }

    getAllSettings(): setting[] {
        if (this.settingsCache != null) {
            return this.settingsCache;
        }
        const settingsJSON = localStorage.getItem(this.localStorageKey);
        let settings: setting[] = [];
        if ( settingsJSON != null) {
            settings = <setting[]>JSON.parse(settingsJSON);
        }
        this.settingsCache = settings;
        return settings;
    }
}

interface setting {
    name: string;
    value: any;
}
